import { render, staticRenderFns } from "./hiddenlistNotif.vue?vue&type=template&id=3d163582"
import script from "./hiddenlistNotif.vue?vue&type=script&lang=js"
export * from "./hiddenlistNotif.vue?vue&type=script&lang=js"
import style0 from "./hiddenlistNotif.vue?vue&type=style&index=0&id=3d163582&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports